export default __webpack_public_path__ + "static/media/Kicks and Stomps.22333a00.png";